import React from 'react';
import Select from 'react-select';

// Styles alignés sur le design system (tokens de index.css)
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 'var(--radius)',
    borderColor: state.isFocused ? 'var(--color-primary)' : 'var(--color-border)',
    boxShadow: state.isFocused ? '0 0 0 3px var(--color-primary-light)' : 'none',
    fontSize: 14,
    fontFamily: 'inherit',
    transition: 'border-color 150ms ease, box-shadow 150ms ease',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--color-primary)' : 'var(--color-border-strong)',
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--color-text-muted)',
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var(--color-text)',
  }),
  input: (base) => ({
    ...base,
    color: 'var(--color-text)',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 'var(--radius)',
    border: '1px solid var(--color-border)',
    boxShadow: 'var(--shadow-md)',
    zIndex: 1100,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1100,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 14,
    color: state.isSelected ? '#fff' : 'var(--color-text)',
    backgroundColor: state.isSelected
      ? 'var(--color-primary)'
      : state.isFocused
        ? 'var(--color-primary-soft)'
        : 'transparent',
    '&:active': {
      backgroundColor: 'var(--color-primary-light)',
    },
  }),
  noOptionsMessage: (base) => ({
    ...base,
    fontSize: 14,
    color: 'var(--color-text-muted)',
  }),
};

/**
 * Select avec recherche intégrée (remplace les <select> natifs sur les
 * longues listes : clients, articles, devis).
 *
 * @param {Array}    options     [{ value, label }]
 * @param {*}        value       valeur sélectionnée (id brut, pas l'objet option)
 * @param {Function} onChange    reçoit la valeur brute ('' si effacé)
 * @param {string}   placeholder
 * @param {boolean}  required    active la validation HTML native du formulaire
 * @param {boolean}  isClearable croix pour vider la sélection (défaut true)
 */
function SearchSelect({ options, value, onChange, placeholder = 'Sélectionner...', required = false, isClearable = true }) {
  const selected = options.find(o => String(o.value) === String(value)) || null;

  return (
    <div style={{ position: 'relative' }}>
      <Select
        options={options}
        value={selected}
        onChange={(opt) => onChange(opt ? opt.value : '')}
        placeholder={placeholder}
        isClearable={isClearable}
        isSearchable
        styles={selectStyles}
        menuPortalTarget={document.body}
        noOptionsMessage={() => 'Aucun résultat'}
        loadingMessage={() => 'Chargement...'}
      />
      {required && (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{ position: 'absolute', opacity: 0, height: 0, width: '100%', bottom: 0, left: 0, pointerEvents: 'none' }}
          value={selected ? String(selected.value) : ''}
          onChange={() => {}}
          required
        />
      )}
    </div>
  );
}

export default SearchSelect;
